// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CMPiLTdwF_1jEn {
  margin-top: var(--ds-space-500, 40px);
}
.us8PDi1oPKAHEj {
  height: 20px;
  margin: var(--ds-space-150, 12px) var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface, #ffffff);
  cursor: progress;
  animation-name: FgrWUXpNx1NsEF;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes FgrWUXpNx1NsEF {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .us8PDi1oPKAHEj {
    animation: none;
  }
}
`, ""]);
// Exports
export var skeletonWrapper = `CMPiLTdwF_1jEn`;
export var skeletonPopoverOption = `us8PDi1oPKAHEj`;
export var shimmer = `FgrWUXpNx1NsEF`;
export default ___CSS_LOADER_EXPORT___;
